// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCache } from '../../DataCache';
import { BrandingToolLinkGenerator } from './Branding/BrandingToolLinkGenerator';
import { BaseExtLink } from './BaseExtLink';
import { ResourcesManager } from '../../properties/ResourcesManager';
export class AutochartistIFrameExtLink extends BaseExtLink {
    constructor() {
        super(...arguments);
        this.brokerID = '';
        this.secretKey = '';
        this.accountType = '';
    }
    update(brandingTool, extLinkMessage) {
        var _a, _b, _c;
        if (brandingTool) {
            this.brokerID = (_a = brandingTool.brokerId) !== null && _a !== void 0 ? _a : this.brokerID;
            this.secretKey = (_b = brandingTool.secretKey) !== null && _b !== void 0 ? _b : this.secretKey;
            this.accountType = (_c = brandingTool.accountType) !== null && _c !== void 0 ? _c : this.accountType;
        }
        super.update(brandingTool, extLinkMessage);
    }
    generateUrl() {
        var _a;
        const userID = DataCache.getUserID();
        const url = BrandingToolLinkGenerator.generateAutochartistIFrameLink(this, userID ? `${userID}` : '', ResourcesManager.extLinkLocaleName());
        if (url) {
            this.url = url;
            (_a = this.updateValue) === null || _a === void 0 ? void 0 : _a.call(this, url);
        }
    }
}
